import { RootState } from '@app/redux/root-reducer';

export const selectCustomerState = (store: RootState) => store.customerSlice.customers;
